export var ExportErrorCodes;
(function (ExportErrorCodes) {
    ExportErrorCodes["ConnectionNotFound"] = "export.connectionNotFound";
    ExportErrorCodes["IcmBadRequest"] = "export.icm.badRequest";
    ExportErrorCodes["IcmClientError"] = "export.icm.clientError";
    ExportErrorCodes["IcmServerError"] = "export.icm.serverError";
    ExportErrorCodes["IcmApiKeyInvalid"] = "export.icm.ApiKeyInvalid";
    ExportErrorCodes["IcmDuplicateKeyError"] = "export.icm.duplicateKeyError";
    ExportErrorCodes["IcmUnmatchedColumnsError"] = "export.icm.unmatchedColumnsError";
    ExportErrorCodes["IcmUnknownExportError"] = "export.icm.unknownExportError";
    ExportErrorCodes["IcmConnectionResetError"] = "export.icm.connectionResetError";
    ExportErrorCodes["IcmRowsAlreadyExistError"] = "export.icm.rowsAlreadyExistError";
    ExportErrorCodes["InternalServerError"] = "export.internalServerError";
    ExportErrorCodes["TqBadCreds"] = "export.tq.badCreds";
    ExportErrorCodes["TqJsonSchemaError"] = "export.tq.jsonSchemaError";
    ExportErrorCodes["TqSingerStreamError"] = "export.tq.singerStreamError";
    ExportErrorCodes["TqTargetError"] = "export.tq.targetError";
    ExportErrorCodes["TqPostgresError"] = "export.tq.postgresError";
    ExportErrorCodes["TqBadHeaders"] = "export.tq.badHeaders";
    ExportErrorCodes["TqpGenericError"] = "export.tqp.genericError";
    ExportErrorCodes["TqpApiKeyInvalid"] = "export.tqp.apiKeyInvalid";
    ExportErrorCodes["TqpMissingConfigurationError"] = "export.tqp.missingConfigurationError";
    ExportErrorCodes["TqpConcurrentExportError"] = "export.tqp.concurrentExportError";
    ExportErrorCodes["WorkdayDataValidationError"] = "export.workday.workdayDataValidationError";
    ExportErrorCodes["WorkdayInvalidUsernameOrPassword"] = "export.workday.invalidUsernameOrPassword";
    ExportErrorCodes["WorkdayTotalFailureError"] = "export.workday.totalFailureError";
    ExportErrorCodes["WorkdayApiError"] = "export.workday.workdayApiError";
    ExportErrorCodes["SalesforceBadDataThresholdError"] = "export.salesforce.badDataThresholdError";
    ExportErrorCodes["SalesforceInvalidDateFormatError"] = "export.salesforce.invalidDateFormatError";
    ExportErrorCodes["SalesforceInvalidIdError"] = "export.salesforce.invalidIdError";
    ExportErrorCodes["SalesforcePermissionMissingError"] = "export.salesforce.permissionMissingError";
    ExportErrorCodes["SalesforceApiError"] = "export.salesforce.salesforceApiError";
    ExportErrorCodes["SftpTransportError"] = "export.sftp.transportError";
    ExportErrorCodes["SftpAuthenticationError"] = "export.sftp.authenticationError";
    ExportErrorCodes["SftpServerError"] = "export.sftp.serverError";
    ExportErrorCodes["SftpEncryptionFailedError"] = "export.sftp.encryptionFailedError";
    ExportErrorCodes["SftpExcelFileTooLargeError"] = "export.sftp.excelFileTooLargeError";
    ExportErrorCodes["AmazonS3AccessDeniedError"] = "export.amazonS3.accessDeniedError";
    ExportErrorCodes["AmazonS3ExcelFileTooLargeError"] = "export.amazonS3.excelFileTooLargeError";
    ExportErrorCodes["SnowflakeClientError"] = "export.snowflake.clientError";
    ExportErrorCodes["SnowflakeServerError"] = "export.snowflake.serverError";
    ExportErrorCodes["MsSqlOperationalError"] = "export.msSql.operationalError";
    ExportErrorCodes["MsSqlIntegrityError"] = "export.msSql.integrityError";
    ExportErrorCodes["MsSqlTableNotFoundError"] = "export.msSql.tableNotFoundError";
    ExportErrorCodes["MsSqlTableSchemaMismatchError"] = "export.msSql.tableSchemaMismatchError";
    ExportErrorCodes["MsSqlDataError"] = "export.msSql.dataError";
    ExportErrorCodes["MsSqlProgrammingError"] = "export.msSql.programmingError";
    ExportErrorCodes["MsSqlNotSupportedError"] = "export.msSql.notSupportedError";
    ExportErrorCodes["OneDriveAccessDeniedError"] = "export.oneDrive.accessDeniedError";
    ExportErrorCodes["OneDriveApiError"] = "export.oneDrive.oneDriveApiError";
    ExportErrorCodes["GSheetsMaxCellExceededError"] = "export.gsheets.maxCellLimitError";
    ExportErrorCodes["TableauProjectNotFound"] = "export.tableau.projectNotFound";
    ExportErrorCodes["TableauSiteNotFound"] = "export.tableau.siteNotFound";
    ExportErrorCodes["TableauInvalidCredentials"] = "export.tableau.invalidCredentials";
    ExportErrorCodes["TableauConnectionFailed"] = "export.tableau.connectionFailed";
    ExportErrorCodes["TableauApiError"] = "tableau.tableauApiError";
    ExportErrorCodes["PowerBIWorkspaceNotFound"] = "export.powerbi.workspaceNotFound";
    ExportErrorCodes["PowerBIApiError"] = "export.powerbi.powerbiApiError";
    ExportErrorCodes["UnexpectedError"] = "export.unexpected";
})(ExportErrorCodes || (ExportErrorCodes = {}));
// Map of error code used in tap/target to ExportErrorCode
export const SingerErrorCodeToExportErrorCode = new Map([
    ['amazonS3.accessDeniedError', ExportErrorCodes.AmazonS3AccessDeniedError],
    ['sftp.transportError', ExportErrorCodes.SftpTransportError],
    ['sftp.authenticationError', ExportErrorCodes.SftpAuthenticationError],
    ['sftp.serverError', ExportErrorCodes.SftpServerError],
    ['sftp.encryptionFailedError', ExportErrorCodes.SftpEncryptionFailedError],
    ['MsSqlOperationalError', ExportErrorCodes.MsSqlOperationalError],
    ['MsSqlIntegrityError', ExportErrorCodes.MsSqlIntegrityError],
    ['MsSqlTableNotFound', ExportErrorCodes.MsSqlTableNotFoundError],
    ['MsSqlTableSchemaMismatch', ExportErrorCodes.MsSqlTableSchemaMismatchError],
    ['MsSqlDataError', ExportErrorCodes.MsSqlDataError],
    ['MsSqlProgrammingError', ExportErrorCodes.MsSqlProgrammingError],
    ['MsSqlNotSupportedError', ExportErrorCodes.MsSqlNotSupportedError],
    ['tqp.genericError', ExportErrorCodes.TqpGenericError],
    ['tqp.apiKeyInvalid', ExportErrorCodes.TqpApiKeyInvalid],
    ['tqp.missingConfigurationError', ExportErrorCodes.TqpMissingConfigurationError],
    ['tqp.concurrentExportError', ExportErrorCodes.TqpConcurrentExportError],
    ['icm.unmatchedColumnsError', ExportErrorCodes.IcmUnmatchedColumnsError],
    ['icm.badRequest', ExportErrorCodes.IcmBadRequest],
    ['icm.clientError', ExportErrorCodes.IcmClientError],
    ['icm.serverError', ExportErrorCodes.IcmServerError],
    ['icm.unknownExportError', ExportErrorCodes.IcmUnknownExportError],
    ['icm.connectionResetError', ExportErrorCodes.IcmConnectionResetError],
    ['icm.duplicateKeyError', ExportErrorCodes.IcmDuplicateKeyError],
    ['icm.rowsAlreadyExistError', ExportErrorCodes.IcmRowsAlreadyExistError],
    ['tq.jsonSchemaError', ExportErrorCodes.TqJsonSchemaError],
    ['tq.singerStreamError', ExportErrorCodes.TqSingerStreamError],
    ['tq.targetError', ExportErrorCodes.TqTargetError],
    ['tq.postgresError', ExportErrorCodes.TqPostgresError],
    ['oneDrive.AccessDenied', ExportErrorCodes.OneDriveAccessDeniedError],
    ['oneDrive.OneDriveApiError', ExportErrorCodes.OneDriveApiError],
    ['gsheets.maxCellLimitError', ExportErrorCodes.GSheetsMaxCellExceededError],
    ['salesforce.badDataThresholdError', ExportErrorCodes.SalesforceBadDataThresholdError],
    ['salesforce.invalidDateFormatError', ExportErrorCodes.SalesforceInvalidDateFormatError],
    ['salesforce.invalidIdError', ExportErrorCodes.SalesforceInvalidIdError],
    ['salesforce.permissionMissingError', ExportErrorCodes.SalesforcePermissionMissingError],
    ['salesforce.salesforceApiError', ExportErrorCodes.SalesforceApiError],
    ['snowflake.clientError', ExportErrorCodes.SnowflakeClientError],
    ['tableau.projectNotFound', ExportErrorCodes.TableauProjectNotFound],
    ['tableau.siteNotFound', ExportErrorCodes.TableauSiteNotFound],
    ['tableau.invalidCredentials', ExportErrorCodes.TableauInvalidCredentials],
    ['tableau.connectionFailed', ExportErrorCodes.TableauConnectionFailed],
    ['tableau.tableauApiError', ExportErrorCodes.TableauApiError],
    ['workday.workdayApiError', ExportErrorCodes.WorkdayApiError],
    ['workday.workdayDataValidationError', ExportErrorCodes.WorkdayDataValidationError],
    ['workday.invalidUsernameOrPassword', ExportErrorCodes.WorkdayInvalidUsernameOrPassword],
    ['workday.totalFailureError', ExportErrorCodes.WorkdayTotalFailureError],
    ['powerbi.workspaceNotFound', ExportErrorCodes.PowerBIWorkspaceNotFound],
    ['powerbi.powerbiApiError', ExportErrorCodes.PowerBIApiError]
]);
// Map of ExportErrorCode to HttpErrorCode
export const ExportErrorCodeToHttpErrorCode = new Map([
    [ExportErrorCodes.AmazonS3AccessDeniedError, 500],
    [ExportErrorCodes.SftpTransportError, 400],
    [ExportErrorCodes.SftpAuthenticationError, 400],
    [ExportErrorCodes.SftpServerError, 500],
    [ExportErrorCodes.SftpEncryptionFailedError, 400],
    [ExportErrorCodes.MsSqlOperationalError, 500],
    [ExportErrorCodes.MsSqlIntegrityError, 500],
    [ExportErrorCodes.MsSqlTableNotFoundError, 500],
    [ExportErrorCodes.MsSqlTableSchemaMismatchError, 500],
    [ExportErrorCodes.MsSqlDataError, 500],
    [ExportErrorCodes.MsSqlProgrammingError, 500],
    [ExportErrorCodes.MsSqlNotSupportedError, 500],
    [ExportErrorCodes.TqpGenericError, 499],
    [ExportErrorCodes.TqpApiKeyInvalid, 401],
    [ExportErrorCodes.TqpMissingConfigurationError, 404],
    [ExportErrorCodes.TqpConcurrentExportError, 400],
    [ExportErrorCodes.IcmUnmatchedColumnsError, 500],
    [ExportErrorCodes.IcmBadRequest, 400],
    [ExportErrorCodes.IcmClientError, 500],
    [ExportErrorCodes.IcmServerError, 500],
    [ExportErrorCodes.IcmUnknownExportError, 500],
    [ExportErrorCodes.IcmConnectionResetError, 500],
    [ExportErrorCodes.IcmDuplicateKeyError, 400],
    [ExportErrorCodes.IcmRowsAlreadyExistError, 400],
    [ExportErrorCodes.TqJsonSchemaError, 500],
    [ExportErrorCodes.TqSingerStreamError, 500],
    [ExportErrorCodes.TqTargetError, 500],
    [ExportErrorCodes.TqPostgresError, 500],
    [ExportErrorCodes.OneDriveAccessDeniedError, 400],
    [ExportErrorCodes.OneDriveApiError, 400],
    [ExportErrorCodes.GSheetsMaxCellExceededError, 400],
    [ExportErrorCodes.SalesforceBadDataThresholdError, 400],
    [ExportErrorCodes.SalesforceInvalidDateFormatError, 400],
    [ExportErrorCodes.SalesforceInvalidIdError, 400],
    [ExportErrorCodes.SalesforcePermissionMissingError, 400],
    [ExportErrorCodes.SalesforceApiError, 400],
    [ExportErrorCodes.SnowflakeClientError, 400],
    [ExportErrorCodes.TableauProjectNotFound, 400],
    [ExportErrorCodes.TableauSiteNotFound, 400],
    [ExportErrorCodes.TableauInvalidCredentials, 400],
    [ExportErrorCodes.TableauConnectionFailed, 400],
    [ExportErrorCodes.TableauApiError, 400],
    [ExportErrorCodes.WorkdayApiError, 400],
    [ExportErrorCodes.WorkdayDataValidationError, 400],
    [ExportErrorCodes.WorkdayInvalidUsernameOrPassword, 401],
    [ExportErrorCodes.WorkdayTotalFailureError, 400],
    [ExportErrorCodes.PowerBIWorkspaceNotFound, 404],
    [ExportErrorCodes.PowerBIApiError, 400]
]);
//# sourceMappingURL=exportErrorCodes.js.map